module.exports = __webpack_public_path__ + "img/648x969.3be1a48f.png";